"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// Returns file name without the extension
function removeExtension(fileName) {
  var extensionIdx = fileName.lastIndexOf('.');
  return extensionIdx > 0 ? fileName.slice(0, extensionIdx) : fileName;
}
var _default = removeExtension;
exports["default"] = _default;